import { createEndpoint } from '@/shared/models/api';
import { Informative } from '@/app/api/morgan-thermal';
import { UserInformation } from '@/app/api/morgan-thermal/user';

export const sendPasswordReset = createEndpoint<Informative>(({fetch}) => (id: UserInformation['id']) => fetch(`/User/SendPasswordReset/${id}`, {method: 'POST'}));